module.exports = __webpack_public_path__ + "static/media/website.4699b688.png";